// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tool_tip_content{display:flex}.tool_tip_content img{margin-right:4px}.card_tooltip{margin-top:4px!important;background:var(--m-theme-color-gray-800)!important;color:var(--m-theme-color-bg)!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
